import { render, staticRenderFns } from "./UpdateOffers.vue?vue&type=template&id=444fe5d1&scoped=true&"
import script from "./UpdateOffers.vue?vue&type=script&lang=js&"
export * from "./UpdateOffers.vue?vue&type=script&lang=js&"
import style0 from "./UpdateOffers.vue?vue&type=style&index=0&id=444fe5d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444fe5d1",
  null
  
)

export default component.exports